import React, { Suspense, useContext } from "react";
import Layout from "./containers/Layout";
import CenterLoading from "./components/UI/CenterLoading";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useRouteMatch,
  Redirect,
} from "react-router-dom";
import { AuthContext } from "./models/AuthContext";
import AdminLayout from "./containers/AdminLayout";

const Home = React.lazy(() => import("./pages/Home"));
const Shop = React.lazy(() => import("./pages/Shop"));
const SingleProduct = React.lazy(() => import("./pages/SingleProductPage"));
const Cart = React.lazy(() => import("./pages/CartPage"));
const CategoryPage = React.lazy(() => import("./pages/CategoryPage"));
const LoginPage = React.lazy(() => import("./pages/AuthPages/Login"));
const Dashboard = React.lazy(() => import("./pages/AdminPages/Dashboard"));
const AllProducts = React.lazy(() => import("./pages/AdminPages/AllProducts"));
const OrderPage = React.lazy(() => import("./pages/AdminPages/OrderPage"));
const SingleOrderPage = React.lazy(() =>
  import("./pages/AdminPages/SingleOrderPage")
);
const AddProduct = React.lazy(() => import("./pages/AdminPages/AddProduct"));
const UpdateProduct = React.lazy(() =>
  import("./pages/AdminPages/UpdateProduct")
);

const PrivateRoute: React.FC<{
  component: any;
  exact?: boolean;
  path: string;
}> = ({ component: Component, ...rest }) => {
  const [, , , isAuth] = useContext(AuthContext);

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        isAuth ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

function ClientApp() {
  let { path } = useRouteMatch();

  console.log(path);

  return (
    <Switch>
      <Layout>
        <Route exact path={path} component={Home} />
        <Route path={`${path}store`} component={Shop} />
        <Route path={`${path}category/:name`} component={CategoryPage} />
        <Route path={`${path}product/:id`} component={SingleProduct} />
        <Route path={`${path}cart`} component={Cart} />
      </Layout>
    </Switch>
  );
}

function DashboardPage() {
  let { path } = useRouteMatch();

  return (
    <AdminLayout>
      <Switch>
        <PrivateRoute exact path={path} component={Dashboard} />
        <PrivateRoute path={`${path}/orders`} component={OrderPage} />
        <PrivateRoute
          path={`${path}/order/:orderId`}
          component={SingleOrderPage}
        />

        <PrivateRoute path={`${path}/products`} component={AllProducts} />
        <PrivateRoute path={`${path}/add_product`} component={AddProduct} />
        <PrivateRoute
          path={`${path}/edit_product/:id`}
          component={UpdateProduct}
        />
      </Switch>
    </AdminLayout>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <Suspense fallback={<CenterLoading />}>
          <Switch>
            <Route exact path="/login" component={LoginPage} />
            <PrivateRoute path="/dashboard" component={DashboardPage} />
            <Route path="/" component={ClientApp} />
          </Switch>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
